

































































import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Action, State} from 'vuex-class'
import Gallery from '@/modules/cms/modules/gallery/model/Gallery'
import LoadingScreen from '@/modules/core/LoadingScreen'
import {Prop} from 'vue-property-decorator'
import {VDataTableHeader} from '@/types'
import Loader from '@/components/Loader.vue';
import ConfirmDeleteGallery from '@/modules/cms/modules/gallery/components/ConfirmDeleteGallery.vue';

/**
 * Lista de galerías
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {ConfirmDeleteGallery, Loader},
})
export default class GalleryList extends Vue {
    @Prop({type: Boolean, default: false})
    public readonly: boolean

    @Prop({type: Boolean, default: false})
    public selectable: boolean

    /**
     * Lista de galerías
     */
    @State(state => state.cms.gallery.galleryList)
    public list: Gallery[]

    /**
     * Acción del store que carga la lista de galerías en el estado de la aplicación
     */
    @Action('cms/gallery/loadGalleryList')
    public loadGalleryList: () => Promise<void>

    public loading = true
    public confirmDelete = false
    public currenGallery = new Gallery()

    public fancyDate (date: Date) {
        return moment(date).format('LLL')
    }

    public get headers () {
        const headers: VDataTableHeader[] = [
            { text: 'Id', value: 'id' },
            { text: 'Nombre', value: 'nombre' },
            { text: 'Fecha de creación', value: 'createAt'},
            { text: 'Fecha de actualización', value: 'updatedAt'},
            { text: 'Número de elementos', value: 'itemCount'},
        ]

        if (!this.readonly) {
            headers.push({ text: 'Acciones', value: 'id', sortable: false })
        }

        return headers
    }

    public selectGallery (gallery: Gallery) {
        this.$emit('select', gallery)
    }

    /**
     * Selecciona una galería para solicitar al usuario la confirmación
     * de eliminación
     */
    public deleteGallery (gallery: Gallery) {
        this.currenGallery = gallery
        this.confirmDelete = true
    }

    /**
     * Carga la lista de galerías al crear el componente
     */
    public async mounted () {
        await this.loadGalleryList()
        this.loading = false
    }
}
